import { render } from "./FastProdEdit.vue?vue&type=template&id=bccbce14&scoped=true"
import script from "./FastProdEdit.vue?vue&type=script&lang=js"
export * from "./FastProdEdit.vue?vue&type=script&lang=js"

import "./FastProdEdit.vue?vue&type=style&index=0&id=bccbce14&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bccbce14"]])

export default __exports__